import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  "aria-label": "volledig scherm inschakelen"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M21 6v5h-2V6h-5V4h7v2zm-2 13v-5h2v7h-7v-2h5zM6 6v5H4V4h7v2H6zm0 13h5v2H4v-7h2v5z"
})));